export interface IconMapping {
  [key: string]: string;
}

export default {
  outlookApple: 'gik-icon-v2 icon-v2-outlookApple',
  outlook: 'gik-icon-v2 icon-v2-outlook',
  add: 'gik-icon-v2 icon-v2-add',
  addFile: 'gik-icon-v2 icon-v2-addFile',
  addFolder: 'gik-icon-v2 icon-v2-addFolder',
  addGroup: 'gik-icon-v2 icon-v2-addGroup',
  addUser: 'gik-icon-v2 icon-v2-addUser',
  alert: 'gik-icon-v2 icon-v2-alert',
  amazon: 'gik-icon-v2 icon-v2-amazon',
  android: 'gik-icon-v2 icon-v2-android',
  'android-o': 'gik-icon-v2 icon-v2-android-o',
  apple: 'gik-icon-v2 icon-v2-apple',
  'apple-o': 'gik-icon-v2 icon-v2-apple-o',
  arrowDown: 'gik-icon-v2 icon-v2-arrowDown',
  arrowheadDoubleLeft: 'gik-icon-v2 icon-v2-arrowheadDoubleLeft',
  arrowheadDoubleRight: 'gik-icon-v2 icon-v2-arrowheadDoubleRight',
  arrowheadDown: 'gik-icon-v2 icon-v2-arrowheadDown',
  arrowheadLeft: 'gik-icon-v2 icon-v2-arrowheadLeft',
  arrowheadRight: 'gik-icon-v2 icon-v2-arrowheadRight',
  arrowheadUp: 'gik-icon-v2 icon-v2-arrowheadUp',
  arrowLeft: 'gik-icon-v2 icon-v2-arrowLeft',
  arrowRight: 'gik-icon-v2 icon-v2-arrowRight',
  arrowUp: 'gik-icon-v2 icon-v2-arrowUp',
  article: 'gik-icon-v2 icon-v2-article',
  attachment: 'gik-icon-v2 icon-v2-attachment',
  backward: 'gik-icon-v2 icon-v2-backward',
  bell: 'gik-icon-v2 icon-v2-bell',
  bookMark: 'gik-icon-v2 icon-v2-bookMark',
  bullhorn: 'gik-icon-v2 icon-v2-bullhorn',
  calendar: 'gik-icon-v2 icon-v2-calendar',
  calendarLarge: 'gik-icon-v2 icon-v2-calendarLarge',
  car: 'gik-icon-v2 icon-v2-car',
  card: 'gik-icon-v2 icon-v2-card',
  cart: 'gik-icon-v2 icon-v2-cart',
  chat: 'gik-icon-v2 icon-v2-chat',
  check: 'gik-icon-v2 icon-v2-check',
  chevronDown: 'gik-icon-v2 icon-v2-chevronDown',
  chevronLeft: 'gik-icon-v2 icon-v2-chevronLeft',
  chevronRight: 'gik-icon-v2 icon-v2-chevronRight',
  chevronUp: 'gik-icon-v2 icon-v2-chevronUp',
  'circle-add-o': 'gik-icon-v2 icon-v2-circle-add-o',
  'circle-add': 'gik-icon-v2 icon-v2-circle-add',
  'circle-alert-o': 'gik-icon-v2 icon-v2-circle-alert-o',
  'circle-alert': 'gik-icon-v2 icon-v2-circle-alert',
  'circle-check-o': 'gik-icon-v2 icon-v2-circle-check-o',
  'circle-check': 'gik-icon-v2 icon-v2-circle-check',
  'circle-close-o': 'gik-icon-v2 icon-v2-circle-close-o',
  'circle-close': 'gik-icon-v2 icon-v2-circle-close',
  'circle-down-o': 'gik-icon-v2 icon-v2-circle-down-o',
  'circle-down': 'gik-icon-v2 icon-v2-circle-down',
  'circle-help-o': 'gik-icon-v2 icon-v2-circle-help-o',
  'circle-help': 'gik-icon-v2 icon-v2-circle-help',
  'circle-info-o': 'gik-icon-v2 icon-v2-circle-info-o',
  'circle-info': 'gik-icon-v2 icon-v2-circle-info',
  'circle-left-o': 'gik-icon-v2 icon-v2-circle-left-o',
  'circle-left': 'gik-icon-v2 icon-v2-circle-left',
  'circle-minus-o': 'gik-icon-v2 icon-v2-circle-minus-o',
  'circle-minus': 'gik-icon-v2 icon-v2-circle-minus',
  'circle-pause-o': 'gik-icon-v2 icon-v2-circle-pause-o',
  'circle-pause': 'gik-icon-v2 icon-v2-circle-pause',
  'circle-right-o': 'gik-icon-v2 icon-v2-circle-right-o',
  'circle-right': 'gik-icon-v2 icon-v2-circle-right',
  'circle-up-o': 'gik-icon-v2 icon-v2-circle-up-o',
  'circle-up': 'gik-icon-v2 icon-v2-circle-up',
  close: 'gik-icon-v2 icon-v2-close',
  coffee: 'gik-icon-v2 icon-v2-coffee',
  compass: 'gik-icon-v2 icon-v2-compass',
  contacts: 'gik-icon-v2 icon-v2-contacts',
  creditcard: 'gik-icon-v2 icon-v2-creditcard',
  cycle: 'gik-icon-v2 icon-v2-cycle',
  dashboard: 'gik-icon-v2 icon-v2-dashboard',
  desktop: 'gik-icon-v2 icon-v2-desktop',
  doc: 'gik-icon-v2 icon-v2-doc',
  docBlank: 'gik-icon-v2 icon-v2-docBlank',
  doubleChevronLeft: 'gik-icon-v2 icon-v2-doubleChevronLeft',
  doubleChevronRight: 'gik-icon-v2 icon-v2-doubleChevronRight',
  download: 'gik-icon-v2 icon-v2-download',
  duplicate: 'gik-icon-v2 icon-v2-duplicate',
  edit: 'gik-icon-v2 icon-v2-edit',
  editWithLine: 'gik-icon-v2 icon-v2-editWithLine',
  end: 'gik-icon-v2 icon-v2-end',
  excel: 'gik-icon-v2 icon-v2-excel',
  facebook: 'gik-icon-v2 icon-v2-facebook',
  female: 'gik-icon-v2 icon-v2-female',
  fileError: 'gik-icon-v2 icon-v2-fileError',
  filter: 'gik-icon-v2 icon-v2-filter',
  firstAid: 'gik-icon-v2 icon-v2-firstAid',
  firstAflagid: 'gik-icon-v2 icon-v2-flag',
  flowers: 'gik-icon-v2 icon-v2-flowers',
  folder: 'gik-icon-v2 icon-v2-folder',
  folderOpen: 'gik-icon-v2 icon-v2-folderOpen',
  forward: 'gik-icon-v2 icon-v2-forward',
  fundraising: 'gik-icon-v2 icon-v2-fundraising',
  fundraisingLarge: 'gik-icon-v2 icon-v2-fundraisingLarge',
  game: 'gik-icon-v2 icon-v2-game',
  gear: 'gik-icon-v2 icon-v2-gear',
  gift: 'gik-icon-v2 icon-v2-gift',
  GIKHeart: 'gik-icon-v2 icon-v2-GIKHeart',
  GIKLogo: 'gik-icon-v2 icon-v2-GIKLogo',
  global: 'gik-icon-v2 icon-v2-global',
  google: 'gik-icon-v2 icon-v2-google',
  hamburgerMenu: 'gik-icon-v2 icon-v2-hamburgerMenu',
  'heart-o': 'gik-icon-v2 icon-v2-heart-o',
  heart: 'gik-icon-v2 icon-v2-heart',
  help: 'gik-icon-v2 icon-v2-help',
  home: 'gik-icon-v2 icon-v2-home',
  hourglass: 'gik-icon-v2 icon-v2-hourglass',
  image: 'gik-icon-v2 icon-v2-image',
  inbox: 'gik-icon-v2 icon-v2-inbox',
  info: 'gik-icon-v2 icon-v2-info',
  insertAbover: 'gik-icon-v2 icon-v2-insertAbover',
  insertBelow: 'gik-icon-v2 icon-v2-insertBelow',
  instagram: 'gik-icon-v2 icon-v2-instagram',
  jpg: 'gik-icon-v2 icon-v2-jpg',
  key: 'gik-icon-v2 icon-v2-key',
  light: 'gik-icon-v2 icon-v2-light',
  link: 'gik-icon-v2 icon-v2-link',
  'location-o': 'gik-icon-v2 icon-v2-location-o',
  location: 'gik-icon-v2 icon-v2-location',
  lock: 'gik-icon-v2 icon-v2-lock',
  logout: 'gik-icon-v2 icon-v2-logout',
  loop: 'gik-icon-v2 icon-v2-loop',
  mail: 'gik-icon-v2 icon-v2-mail',
  male: 'gik-icon-v2 icon-v2-male',
  market: 'gik-icon-v2 icon-v2-market',
  maximize: 'gik-icon-v2 icon-v2-maximize',
  meal: 'gik-icon-v2 icon-v2-meal',
  menu: 'gik-icon-v2 icon-v2-menu',
  microsoft: 'gik-icon-v2 icon-v2-microsoft',
  minimize: 'gik-icon-v2 icon-v2-minimize',
  minus: 'gik-icon-v2 icon-v2-minus',
  mobile: 'gik-icon-v2 icon-v2-mobile',
  more: 'gik-icon-v2 icon-v2-more',
  'neg-o': 'gik-icon-v2 icon-v2-neg-o',
  neg: 'gik-icon-v2 icon-v2-neg',
  'neu-o': 'gik-icon-v2 icon-v2-neu-o',
  neu: 'gik-icon-v2 icon-v2-neu',
  pause: 'gik-icon-v2 icon-v2-pause',
  pdf: 'gik-icon-v2 icon-v2-pdf',
  phone: 'gik-icon-v2 icon-v2-phone',
  'photo-o': 'gik-icon-v2 icon-v2-photo-o',
  photo: 'gik-icon-v2 icon-v2-photo',
  'pin-o': 'gik-icon-v2 icon-v2-pin-o',
  pin: 'gik-icon-v2 icon-v2-pin',
  pinterest: 'gik-icon-v2 icon-v2-pinterest',
  'play-o': 'gik-icon-v2 icon-v2-play-o',
  play: 'gik-icon-v2 icon-v2-play',
  popOut: 'gik-icon-v2 icon-v2-popOut',
  'pos-o': 'gik-icon-v2 icon-v2-pos-o',
  pos: 'gik-icon-v2 icon-v2-pos',
  power: 'gik-icon-v2 icon-v2-power',
  ppt: 'gik-icon-v2 icon-v2-ppt',
  profile: 'gik-icon-v2 icon-v2-profile',
  prompt: 'gik-icon-v2 icon-v2-prompt',
  refine: 'gik-icon-v2 icon-v2-refine',
  refresh: 'gik-icon-v2 icon-v2-refresh',
  removeGroup: 'gik-icon-v2 icon-v2-removeGroup',
  removeUser: 'gik-icon-v2 icon-v2-removeUser',
  report: 'gik-icon-v2 icon-v2-report',
  rocket: 'gik-icon-v2 icon-v2-rocket',
  rss: 'gik-icon-v2 icon-v2-rss',
  save: 'gik-icon-v2 icon-v2-save',
  search: 'gik-icon-v2 icon-v2-search',
  server: 'gik-icon-v2 icon-v2-server',
  shake: 'gik-icon-v2 icon-v2-shake',
  share: 'gik-icon-v2 icon-v2-share',
  someSelected: 'gik-icon-v2 icon-v2-someSelected',
  'square-add-o': 'gik-icon-v2 icon-v2-square-add-o',
  'square-add': 'gik-icon-v2 icon-v2-square-add',
  'square-check-o': 'gik-icon-v2 icon-v2-square-check-o',
  'square-check': 'gik-icon-v2 icon-v2-square-check',
  'square-close-o': 'gik-icon-v2 icon-v2-square-close-o',
  'square-close': 'gik-icon-v2 icon-v2-square-close',
  'square-down-o': 'gik-icon-v2 icon-v2-square-down-o',
  'square-down': 'gik-icon-v2 icon-v2-square-down',
  'square-left-o': 'gik-icon-v2 icon-v2-square-left-o',
  'square-left': 'gik-icon-v2 icon-v2-square-left',
  'square-minus-o': 'gik-icon-v2 icon-v2-square-minus-o',
  'square-minus': 'gik-icon-v2 icon-v2-square-minus',
  'square-right-o': 'gik-icon-v2 icon-v2-square-right-o',
  'square-right': 'gik-icon-v2 icon-v2-square-right',
  'star-o': 'gik-icon-v2 icon-v2-star-o',
  star: 'gik-icon-v2 icon-v2-star',
  start: 'gik-icon-v2 icon-v2-start',
  subcategory: 'gik-icon-v2 icon-v2-subcategory',
  support: 'gik-icon-v2 icon-v2-support',
  tablet: 'gik-icon-v2 icon-v2-tablet',
  'tag-o': 'gik-icon-v2 icon-v2-tag-o',
  tag: 'gik-icon-v2 icon-v2-tag',
  target: 'gik-icon-v2 icon-v2-target',
  tee: 'gik-icon-v2 icon-v2-tee',
  'thumbsdown-o': 'gik-icon-v2 icon-v2-thumbsdown-o',
  thumbsdown: 'gik-icon-v2 icon-v2-thumbsdown',
  'thumbsup-o': 'gik-icon-v2 icon-v2-thumbsup-o',
  thumbsup: 'gik-icon-v2 icon-v2-thumbsup',
  'time-o': 'gik-icon-v2 icon-v2-time-o',
  time: 'gik-icon-v2 icon-v2-time',
  toTop: 'gik-icon-v2 icon-v2-toTop',
  trash: 'gik-icon-v2 icon-v2-trash',
  trophy: 'gik-icon-v2 icon-v2-trophy',
  tv: 'gik-icon-v2 icon-v2-tv',
  twitter: 'gik-icon-v2 icon-v2-twitter',
  unknownFile: 'gik-icon-v2 icon-v2-unknownFile',
  unlink: 'gik-icon-v2 icon-v2-unlink',
  unlock: 'gik-icon-v2 icon-v2-unlock',
  upload: 'gik-icon-v2 icon-v2-upload',
  usb: 'gik-icon-v2 icon-v2-usb',
  user: 'gik-icon-v2 icon-v2-user',
  userGroup: 'gik-icon-v2 icon-v2-userGroup',
  vidCam: 'gik-icon-v2 icon-v2-vidCam',
  'view-o': 'gik-icon-v2 icon-v2-view-o',
  view: 'gik-icon-v2 icon-v2-view',
  visitor: 'gik-icon-v2 icon-v2-visitor',
  volume: 'gik-icon-v2 icon-v2-volume',
  wallet: 'gik-icon-v2 icon-v2-wallet',
  wifi: 'gik-icon-v2 icon-v2-wifi',
  'windoze-o': 'gik-icon-v2 icon-v2-windoze-o',
  windoze: 'gik-icon-v2 icon-v2-windoze',
  wishlist: 'gik-icon-v2 icon-v2-wishlist',
  wishlistLarge: 'gik-icon-v2 icon-v2-wishlistLarge',
  word: 'gik-icon-v2 icon-v2-word',
  wrench: 'gik-icon-v2 icon-v2-wrench',
  youTube: 'gik-icon-v2 icon-v2-youTube',
  facebook2019: 'gik-icon-v2 icon-v2-facebook2019',
  copyToClipboard: 'gik-icon-v2 icon-v2-copyToClipboard',
  messenger: 'gik-icon-v2 icon-v2-messenger',
} as IconMapping;
